import Stop from '@material-ui/icons/Stop';

export const legendData = [
	{
		label: 'Sold Out',
		icon: <Stop />,
		color: '#FF8A27',
	},
	{
		label: 'Pending',
		icon: <Stop />,
		color: '#FFD84E',
	},
	{
		label: 'Available',
		icon: <Stop />,
		color: '#52DC19',
	},
	{
		label: 'On Hold',
		icon: <Stop />,
		color: 'rgba(81, 81, 81, 0.79)',
	},
];
